// Copyright (c) 2017 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';

const getColumnHeaders = () => [
    {
        className: 'description',
        id: 'TYPE'
    },
    {
        className: 'amount',
        id: 'AMOUNT'
    },
    {
        className: 'hours',
        id: 'CURRENT_HOURS'
    },
    {
        className: 'adjustment-type',
        id: 'ADJUSTMENT_TYPE'
    },
    {
        className: 'value-of-adjustment',
        id: 'ADJUSTED_HOURS'
    }
];

const DebitLaborPanelRowHeader = () =>
    <section className='debit-labor-panel-row-header'>
        {
            getColumnHeaders().map(column =>
                <span
                    className={column.className}
                    key={column.id}
                >
                    <FormattedMessage id={column.id}/>
                </span>
            )
        }
    </section>;

DebitLaborPanelRowHeader.displayName = 'DebitLaborPanelRowHeader';

export default DebitLaborPanelRowHeader;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-labor-panel/debit-labor-panel-row-header.js